import {AcceptOrderRequest, OrderDetails} from "../api/ApiTypes.ts";
import React, {useState} from "react";
import {useOrderApi} from "../context/ApiContext.tsx";
import SamButton from "./SamButton.tsx";
import CancelButton from "./CancelButton.tsx";
import {isUad36Order} from "../pages/appraiser/orderdetails/orderDetailsDisplay.ts";
import {Uad36Alert} from "./Uad36Notice.tsx";

interface AcceptOrderProps {
    orderId: number,
    onSuccess: () => void;
    onCancel: () => void;
    orderDetails: OrderDetails;
}

export const AcceptOrderForm: React.FC<AcceptOrderProps> = ({
                                                                orderId,
                                                                onSuccess,
                                                                onCancel,
                                                                orderDetails
                                                            }) => {

    const defaultState: AcceptOrderRequest = {
        orderId: orderId,
        forAppraiser: undefined
    };

    const [ formData, setFormData ] = useState<AcceptOrderRequest>(defaultState);
    const orderApi = useOrderApi()

    const handleSubmit = (e : React.FormEvent) => {
        e.preventDefault();

        orderApi.accept(formData).then(_ => {
            onSuccess();
        }).catch(console.log);
    }

    const handleCancel = () => {
        setFormData(defaultState);
        onCancel();
    }

    const uad36Order = isUad36Order(orderDetails);


    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            {uad36Order && <Uad36Alert/>}
            <div className="flex justify-end space-x-2">
                <CancelButton
                    type="button"
                    onClick={handleCancel}
                >
                    Cancel
                </CancelButton>
                <SamButton
                    type="submit"
                >
                    Accept
                </SamButton>
            </div>
        </form>
    )
}